module.exports = __webpack_public_path__ + "448750fd818f76ee5d2ce0d0307e75cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/home-hero.jpg
// module id = 134
// module chunks = 0